import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-pick-profile',
  templateUrl: './pick-profile.component.html',
  styleUrls: ['./pick-profile.component.scss'],
})
export class PickProfileComponent implements OnInit {
  config = {
    type: 'CONTAINS',
    value: ''
  };
  @Input() selectedProfiles = '';
  profiles = [];
  workingSelectedValues: string[] = [];
  filteredItems: any[] = [];
  constructor(public modalController: ModalController,
    private helper: CommonMessageService,
    private translator: TranslateService,
    private common: CommonService, ) { }

  ngOnInit() {
    this.filteredItems = [...this.profiles];
    console.log('selectedProfiles:::', this.selectedProfiles);
    if (this.selectedProfiles) {
      this.workingSelectedValues = this.selectedProfiles.split(';');
    }
    this.loadConfigs();
  }

  async loadConfigs() {
    const loading = await this.helper.pleaseWaitLoading();
    try {
      const res: any = await this.common.profiles().toPromise();
      loading.dismiss();
      if (!res || !res.length) {
        return;
      }
      this.profiles = JSON.parse(res[0].value);
      this.filteredItems = [...this.profiles];
    } catch (error) {
      loading.dismiss();
      this.helper.errorToast(this.translator.instant('ERROR_OCCURED') + ': ' + error);
      console.log('error.....', error);
    }
  }

  dismiss(data?) {
    this.modalController.dismiss(data);
  }
  changeLayout() {

  }
  save() {
    console.log('Value: ', this.workingSelectedValues);
    this.dismiss({
      result: this.workingSelectedValues
    });
  }

  isChecked(value: string) {
    return this.workingSelectedValues.find((item) => item === value);
  }

  checkboxChange(ev) {
    const { checked, value } = ev.detail;

    if (checked) {
      this.workingSelectedValues = [...this.workingSelectedValues, value];
    } else {
      this.workingSelectedValues = this.workingSelectedValues.filter((item) => item !== value);
    }
  }

  trackItems(index: number, item: any) {
    return item.code;
  }

  searchbarInput(ev) {
    this.filterList(ev.target.value);
  }

  filterList(searchQuery: string | undefined) {
    if (searchQuery === undefined) {
      this.filteredItems = [...this.profiles];
    } else {
      const normalizedQuery = searchQuery.toLowerCase();
      this.filteredItems = this.profiles.filter((item) => {
        return item.label.toLowerCase().includes(normalizedQuery);
      });
    }
  }

  get cantValidate() {
    console.log('workingSelectedValues;;;', this.workingSelectedValues);
    return !this.workingSelectedValues || !this.workingSelectedValues.length;
  }

}
